import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";
import { legalServiceSchema } from "@/components/seo/json-ld";

export const Route = createFileRoute("/aree/diritto-del-lavoro")({
  head: () => seoMeta({
    title: "AI per il diritto del lavoro",
    description: "LexAIPro per giuslavoristi: contratti di lavoro, impugnazioni di licenziamento, ricorsi al giudice del lavoro con assistenza AI.",
    path: "/aree/diritto-del-lavoro",
  }),
  component: () => (
    <ContentPage
      extraSchemas={[legalServiceSchema({ name: "LexAIPro - AI per il diritto del lavoro", description: "Assistenza AI per contratti di lavoro, licenziamenti e contenzioso giuslavoristico.", path: "/aree/diritto-del-lavoro" })]}
      eyebrow="Aree di pratica"
      title="LexAIPro per il diritto del lavoro"
      lead="Ricerca su CCNL, giurisprudenza del lavoro e Inps; redazione di contratti e ricorsi; analisi di lettere di licenziamento."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Aree",path:"/aree/diritto-del-lavoro"},{name:"Diritto del lavoro",path:"/aree/diritto-del-lavoro"}]}
      sections={[
        { heading: "Casi d'uso", bullets: ["Contratti di lavoro subordinato e parasubordinato","Impugnazioni di licenziamento","Conciliazioni e transazioni","Ricorsi al giudice del lavoro","Verifica conformità CCNL"] },
      ]}
      cta={{ label: "Prova gratis", to: "/signup" }}
      heroImage={pickContent(9)}
      updated="2026"
    />
  ),
});
